class BrandCollections extends HTMLElement {
  constructor() {
    super();

    this.swiperWrapper = this.querySelector('.swiper');
    this.sliderControls = this.querySelector('.swiper-controls');
    this.sliderOptions = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: false,
      grabCursor: true,
      allowTouchMove: true,
      threshold: 2
    };

    if (this.sliderControls) {
      this.sliderOptions.navigation = {
        nextEl: this.sliderControls.querySelector('.swiper-button-next'),
        prevEl: this.sliderControls.querySelector('.swiper-button-prev')
      };
    }
  }

  get filterButtons() {
    return this.querySelectorAll('.brand-collections-filter');
  }

  connectedCallback() {
    this.sliderInstance = new window.FoxTheme.Carousel(this.swiperWrapper, this.sliderOptions, []);
    this.sliderInstance.init();

    for (const button of this.filterButtons) {
      button.addEventListener('click', () => {
        this.filterButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
      });
    }
  }
}
customElements.define('brand-collections', BrandCollections);